module.exports = __webpack_public_path__ + "static/LogoWebsite-f56c4bcd753eb9c026b9a24007d76cd8.jpg";